// project-imports
import {
    CREATE_ORDERS_BEGIN,
    CREATE_ORDERS_SUCCESS,
    CREATE_ORDERS_FAILURE,
    GET_ORDERS_BEGIN,
    GET_ORDERS_SUCCESS,
    GET_ORDERS_FAILURE,
    DOWNLOAD_EBOOK_BEGIN,
    DOWNLOAD_EBOOK_SUCCESS,
    DOWNLOAD_EBOOK_FAILURE,
    CLOSE_PAYMENT_SUCCESS_MODAL,
    GET_ALL_ORDERS_BEGIN,
    GET_ALL_ORDERS_SUCCESS,
    GET_ALL_ORDERS_FAILURE
} from "../constants/actions";

// State variable initialization
const initialState = {
    orderLoading: false,
    ordersError: null,
    isPaymentSuccess: false,
    allOrders: [],
    orders: [],
    newOrder: []
};

const orderReducer = (state = initialState, action) => {

    if (action.type === GET_ALL_ORDERS_BEGIN) {
        // Set loading state
        return {
            ...state,
            isPaymentSuccess: false,
            orderLoading: action.payload,
            ordersError: null,
        };
    }

    if (action.type === GET_ALL_ORDERS_SUCCESS) {
        // Update state with all order 
        return {
            ...state,
            orderLoading: false,
            isPaymentSuccess: false,
            allOrders: Array.isArray(action.payload) ? action.payload : [],
            ordersError: null,
        };
    }

    if (action.type === GET_ALL_ORDERS_FAILURE) {
        // Set error state
        return {
            ...state,
            orderLoading: false,
            isPaymentSuccess: false,
            ordersError: action.payload,
        };
    }

    if (action.type === GET_ORDERS_BEGIN) {
        // Set loading state
        return {
            ...state,
            isPaymentSuccess: false,
            orderLoading: action.payload,
            ordersError: null,
        };
    }

    if (action.type === GET_ORDERS_SUCCESS) {
        // Update state with all order 
        return {
            ...state,
            orderLoading: false,
            isPaymentSuccess: false,
            orders: Array.isArray(action.payload) ? action.payload : [],
            ordersError: null,
        };
    }

    if (action.type === GET_ORDERS_FAILURE) {
        // Set error state
        return {
            ...state,
            orderLoading: false,
            isPaymentSuccess: false,
            ordersError: action.payload,
        };
    }

    if (action.type === CREATE_ORDERS_BEGIN) {
        // Set loading state
        return {
            ...state,
            newOrder: [],
            isPaymentSuccess: false,
            orderLoading: action.payload,
            ordersError: null,
        };
    }

    if (action.type === CREATE_ORDERS_SUCCESS) {
        const orderData = action?.payload?.success && action?.payload?.newLsaOrder?.success[0];
        // Update state with added order
        return {
            ...state,
            newOrder: orderData || [],
            isPaymentSuccess: false,
            orderLoading: false,
            ordersError: null,
        };
    }

    if (action.type === CREATE_ORDERS_FAILURE) {

        // Set error state
        return {
            ...state,
            newOrder: [],
            orderLoading: false,
            isPaymentSuccess: false,
            ordersError: action.payload,
        };
    }

    if (action.type === DOWNLOAD_EBOOK_BEGIN) {
        // Set loading state
        return {
            ...state,
            newOrder: [],
            isPaymentSuccess: false,
            orderLoading: action.payload,
            ordersError: null,
        };
    }

    if (action.type === DOWNLOAD_EBOOK_SUCCESS) {
        let isPaymentSuccess = action.payload?.orderType === "free" ? false : true;
        return {
            ...state,
            newOrder: [],
            isPaymentSuccess: isPaymentSuccess,
            orderLoading: false,
            ordersError: null,
        };
    }

    if (action.type === DOWNLOAD_EBOOK_FAILURE) {

        // Set error state
        return {
            ...state,
            newOrder: [],
            orderLoading: false,
            isPaymentSuccess: false,
            ordersError: action.payload,
        };
    }

    if (action.type === CLOSE_PAYMENT_SUCCESS_MODAL) {

        // Set error state
        return {
            ...state,
            newOrder: [],
            orderLoading: false,
            isPaymentSuccess: false,
            ordersError: action.payload,
        };
    }

    return state;
};

export default orderReducer;
